module.exports = __webpack_public_path__ + "static/media/progress_failed.8660f111.png";